import { handleOAuth } from '../../../actions/integration/methods/handle-oauth'
import { useAssetStore } from '@/stores/asset'

/**
 * Handles OAuth response after platform authorization
 * @param {number} platformId - ID of the platform
 * @param {Object} data - OAuth response data
 * @param {Array} integrations - Array of integration objects to update
 * @returns {Promise<Object>} Result object with success status and integration information
 */
export const handleOAuthResponse = async (platformId, data, integrations) => {
  const assetStore = useAssetStore()
  const integration = integrations.find(i => i.id === platformId)
  
  if (!integration) {
    return { success: false, name: 'Unknown', integration: null }
  }
  
  try {
    const response = await handleOAuth(
      data,
      `${window.location.origin}/settings?integration=${platformId}&tab=integrations`,
      assetStore.assetId,
      platformId
    )

    // Duplicate hesap kontrolü - handleOAuth'tan dönen özel nesneyi kontrol et
    if (response && response.isDuplicate === true) {
      return {
        success: false,
        isDuplicate: true,
        name: integration.name,
        integration,
        message: response.message,
        emailAddress: response.emailAddress,
        accountId: response.accountId
      }
    }

    // For non-Google integrations, mark as connected
    if (platformId !== 6) {
      integration.connected = true
    }
    
    return {
      success: true,
      name: integration.name,
      integration
    }
  } catch (error) {
    console.error('Error handling OAuth response:', error)
    return {
      success: false,
      name: integration.name,
      integration
    }
  }
}
